import {inject} from '@angular/core';
import {
  HttpEvent,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import {Observable} from 'rxjs';
import {select, Store} from '@ngrx/store';
import {selectOrganizationId} from '../../context-data/context-data.selectors';
import {mergeMap, take} from 'rxjs/operators';

export const setOrganizationHeader: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  const store = inject(Store);

  return store.pipe(
    select(selectOrganizationId),
    take(1),
    mergeMap(organizationId => {
      if (req.url.includes('v3/commerce')) {
        const clonedReq = req.clone({
          setHeaders: {'Commerce-Organization-Id': String(organizationId)},
        });
        return next(clonedReq);
      } else {
        return next(req);
      }
    }),
  );
};
